import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const box = (theme: Theme) => css`
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid ${theme.palette.neutral[300]};

  box-sizing: content-box;
  min-height: 22px;
  padding: 0 0 ${size[4]};

  ${breakpoint.up('md')} {
    min-height: 24px;
    padding: ${size[4]} 0 ${size[8]};
  }
`

export const focused = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.brand[500]};
  box-shadow: 0 1px 0 0 ${theme.palette.brand[500]};
`

export const error = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.error[500]};
  box-shadow: 0 1px 0 0 ${theme.palette.error[500]};
`
